import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../i18n';
import AttendanceIcon from '../../../../icons/AttendanceIcon';
import TileDrawerHeaderLayout from '../../../shared/TileDrawerHeaderLayout';

const DrawerHeader = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  return (
    <TileDrawerHeaderLayout icon={AttendanceIcon} color="warning">
      {t('attendance', { ns: i18nNS.GLOSSARY })}
    </TileDrawerHeaderLayout>
  );
};

export default DrawerHeader;
